import React, { useEffect, useState } from "react";
import styles from "./ModalVkIntegration.module.scss";
import { LogoVkIcon } from "../../assets/icons/LogoVkIcon";
import Button from "../../ui/Button/Button";
import Title from "../../ui/Title/Title";
import Input from "../../ui/Input/Input";
import { ClipLoader } from "react-spinners";
import { useDispatch, useSelector } from "react-redux";
import { BlockTooltip } from "../BlockTooltip/BlockTooltip";
import {
  stepsDataAccessKey,
  stepsDataGroupId,
} from "../../assets/consts/tooltipDataVk";
import { TooltipProvider } from "../../context/TooltipContext";
import { useLocation } from "react-router-dom";
import { useModal } from "../../context/ModalContext";
import {
  setActiveTg,
  setNewBot,
  setNewTg,
} from "../../store/slices/integrationSlice";
import { setNewAvito } from "../../store/slices/avitoSlice";
import { setNewVk } from "../../store/slices/vkSlice";
import { Modal } from "../../ui/Modal/Modal";
import {
  getVkIntegration,
  initVk,
} from "../../utils/api/actions/integrations/vk";

const SuccessInitVk = ({ closeModal, closeAddIntegrationModal }) => {
  const [countdown, setCountdown] = useState(5); // Начальный таймер на 5 секунд
  const dispatch = useDispatch();
  const location = useLocation();

  const externalId = location.pathname.split("/").pop();
  const id = localStorage.getItem("@storage_User_Id");

  useEffect(() => {
    // Устанавливаем интервал для обратного отсчета
    const timer = setInterval(() => {
      setCountdown((prevCountdown) => prevCountdown - 1);
    }, 1000);

    // Закрываем сообщение после завершения обратного отсчета
    if (countdown === 0) {
      closeModal();
      closeAddIntegrationModal();
      if (location.pathname.split("/").length > 3) {
        dispatch(getVkIntegration(id, externalId));
      }
      dispatch(setActiveTg(null));
      dispatch(setNewTg(null));
      dispatch(setNewBot(null));
      dispatch(setNewAvito(null));
      dispatch(setNewVk(null));
    }

    // Очищаем интервал при размонтировании компонента или завершении обратного отсчета
    return () => clearInterval(timer);
  }, [
    countdown,
    closeModal,
    dispatch,
    closeAddIntegrationModal,
    externalId,
    id,
    location.pathname,
  ]);

  return (
    <div className={styles.successMessage}>
      <h2>Вы успешно подключили ВКонтакте!</h2>
      <div>
        <ClipLoader /> Окно закроется через {countdown} секунд.
      </div>
    </div>
  );
};

export const ModalVkIntegration = ({ visible, handlerClose }) => {
  const dispatch = useDispatch();

  const { closeModal } = useModal();

  const user = useSelector((state) => state?.user?.data);
  const { isLoadingVk, isConnectedVk } = useSelector((state) => state?.vk);

  const [valueAccessKey, setValueAccessKey] = useState("");
  const [valueGroupId, setValueGroupId] = useState("");
  const [errors, setErrors] = useState({ accessKey: "", groupId: "" });
  const [error, setError] = useState("");

  const handleSendData = () => {
    const data = {
      userId: user?.id || "",
      groupKey: valueAccessKey.trim(),
      groupId: valueGroupId.trim(),
    };
    dispatch(initVk(data, setError));
  };

  const validateInputs = () => {
    const newErrors = {
      accessKey: valueAccessKey.trim() ? "" : "Поле не может быть пустым",
      groupId: valueGroupId.trim() ? "" : "Поле не может быть пустым",
    };
    setErrors(newErrors);
    return !Object.values(newErrors).some((error) => error !== "");
  };

  const handlerInput = (e) => {
    const { name, value } = e.target;
    if (name === "accessKey") setValueAccessKey(value);
    if (name === "groupId") setValueGroupId(value);
  };

  useEffect(() => {
    setErrors((prev) => ({
      ...prev,
      accessKey: valueAccessKey.trim() ? "" : "Поле не может быть пустым",
      groupId: valueGroupId.trim() ? "" : "Поле не может быть пустым",
    }));
  }, [valueAccessKey, valueGroupId]);

  return (
    <Modal visible={visible} handleClose={handlerClose}>
      <div className={styles.layout}>
        <div className={styles.header}>
          <Title title="Новая интеграция" className={styles.title} />
          <LogoVkIcon fillF={"#0077FF"} fillS={"white"} />
        </div>

        {!isConnectedVk ? (
          <div className={styles.content}>
            <TooltipProvider>
              <div className={styles.inputGroup}>
                <div className={styles.inputContainer}>
                  <Input
                    
                    name="accessKey"
                    label={
                      <div style={{ display: "flex", gap: "8px" }}>
                        Ключ доступа{" "}
                        <BlockTooltip
                          tooltipId={"accessKey"}
                          stepsData={stepsDataAccessKey}
                        />
                      </div>
                    }
                    labelStyle={styles.labelInput}
                    className={styles.child}
                    backgroundStyle={styles.labelBackground}
                    inputStyle={`${styles.input}`}
                    value={valueAccessKey}
                    placeholder={"Ключ"}
                    type={"text"}
                    onChange={handlerInput}
                  />
                  {error && <span className={styles.errorText}>{error}</span>}
                  {errors.accessKey && (
                    <span className={styles.errorText}>{errors.accessKey}</span>
                  )}
                </div>
              </div>
              <div className={styles.inputGroup}>
                <div className={styles.inputContainer}>
                  <Input
                    className={styles.child}
                    name="groupId"
                    label={
                      <div style={{ display: "flex", gap: "8px" }}>
                        Group id{" "}
                        <BlockTooltip
                          tooltipId={"groupId"}
                          stepsData={stepsDataGroupId}
                        />
                      </div>
                    }
                    labelStyle={styles.labelInput}
                    backgroundStyle={styles.labelBackground}
                    inputStyle={`${styles.input}`}
                    value={valueGroupId}
                    placeholder={"Id"}
                    type={"text"}
                    onChange={handlerInput}
                  />
                  {error && <span className={styles.errorText}>{error}</span>}
                  {errors.groupId && (
                    <span className={styles.errorText}>{errors.groupId}</span>
                  )}
                </div>
              </div>
            </TooltipProvider>
            <Button
              title="Отправить"
              onClick={() => (validateInputs() ? handleSendData() : undefined)}
              className={styles.nextButton}
              titleClassName={styles.nextButtonTitle}
              leftIcon={
                isLoadingVk ? <ClipLoader size={20} color="white" /> : null
              }
            />
          </div>
        ) : (
          <SuccessInitVk
            closeModal={handlerClose}
            closeAddIntegrationModal={closeModal}
          />
        )}
      </div>
    </Modal>
  );
};
